<template>

    <div class="container">

        <div id="messages"></div>

        <div class="checklist-header">
            <h1>
                <i @click="loadHistory()" class="fa fa-history"></i>
                Production History
                <span class="h4 checklist-subtitle">
                    <span :class="{ subtitleCurrentWeek: week.isCurrentWeek }">Week {{ week.num }}</span>,
                    <span v-if="week.isCurrentWeek">commenced</span>
                    <span v-else>commencing</span>
                    {{ week.start }}
                </span>
            </h1>
            <div class="checklist-week-nav">
                <button class="btn btn-default" @click="weekNavBack()" title="Previous Week"><i class="fas fa-arrow-alt-left"></i></button>
                <button class="btn btn-default"  @click="weekNavForward()" title="Next Week"><i class="fas fa-arrow-alt-right"></i></button>
            </div>
        </div>

        <div class="ps-filter-row row-filter">

            <div :class="['ps-filter-col', 'col-filter', 'col-filter-active']">
                <v-select
                    :options="metric_select_options"
                    :reduce="m => m.id"
                    label="name"
                    v-model="metric"
                    :disabled="loading"
                    :searchable="false"
                    :clearable="false"
                    class="tt-filter"
                ></v-select>
            </div>

        </div>

        <table class="table">
            <thead>
                <tr>
                    <th scope="col">&nbsp;</th>
                    <th v-for="day in week.days" scope="col">{{ day }}</th>
                    <th scope="col">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users">
                    <th scope="row">{{ user.name }}</th>
                    <td v-for="(values, date, index) in user.history"
                        :class="[
                            'ph-value-cell',
                            cellHighlighting(values),
                            {'grey-zero-value': values[metric] === '0'}
                        ]"
                        @click="loadUsersCompleted(user.id, date, index)"
                    >
                        {{ formatMetric(metric, values[metric]) }}
                    </td>
                </tr>
            </tbody>
        </table>

        <v-easy-dialog v-model="usersCompletedModalVisible" :width="'800px'">
            <div class="ph-dialog-wrap">

                <div class="ph-dialog-title">
                    Completed by <b>{{ usersCompletedModalUser }}</b> during <b>{{ usersCompletedModalDateRange }}</b>
                </div>

                <div class="ph-dialog-content">

                    <div v-if="loading">Loading...</div>

                    <div v-else v-for="item in usersCompleted" class="ph-dialog-item">
                        <div class="ph-dialog-item-title">
                            <span>
                                <a :href="item.quote_url" title="View Quote" target="_blank">{{ item.quote_id }}</a> -
                                <a :href="item.item_url" title="View Item" target="_blank">{{ item.item_id }}</a>
                            </span>
                            {{ item.title }}
                        </div>
                        <div v-for="process in item.processes" class="ph-dialog-process">
                            <div>{{ process.pretty_name }}</div>
                            <div class="stat ph-dialog-stat">{{ process.est_hours }}h</div>
                            <div v-if="can_view_financials" class="stat ph-dialog-stat">£{{ process.pounds }}</div>
                            <div class="stat ph-dialog-stat">{{ process.updated_at_pretty }}</div>
                        </div>
                    </div>

                </div>

            </div>
        </v-easy-dialog>

    </div>

</template>

<script>

    import miniToastr from "mini-toastr";
    import vSelect from "vue-select";
    import 'vue-select/dist/vue-select.css';
    import api from "../../api";
    import VEasyDialog from 'v-easy-dialog'

    let Vue = window.Vue;

    export default {

        props: {
            week_prop: {
                type: Object,
                required: true,
            },
            users_prop: {
                type: Object,
                required: true
            },
            can_view_financials: {
                type: Boolean,
                default: false
            },
        },

        data: () => ({
            app_url: window.location.protocol + "//" + window.location.host,
            week: {},
            users: {},
            loading: false,
            metric: 'time_percent_efficiency',
            usersCompletedModalVisible: false,
            usersCompleted: [],
            usersCompletedModalUser: '',
            usersCompletedModalDateRange: '',
        }),

        components: {
            miniToastr,
            vSelect,
            VEasyDialog,
        },

        async created() {
            this.week = JSON.parse(JSON.stringify(this.week_prop));
            this.users = JSON.parse(JSON.stringify(this.users_prop));

            await this.loadHistory();
        },

        mounted() {
            miniToastr.init({
                timeout: 3000,
                appendTarget: document.getElementById('messages'),
            });
        },

        destroyed() {},

        methods: {
            updateUrl() {
                history.replaceState(null, "", this.url);
            },
            weekNav(direction) {
                var d = new Date(Date.UTC(this.week.year, 0, 4));
                d.setUTCDate(d.getUTCDate() + (this.week.num - 1) * 7 + (direction * 7));
                var dayOfYear = Math.round((d - new Date(Date.UTC(d.getUTCFullYear(), 0, 1))) / 86400000) + 1;
                var weekDay = (d.getUTCDay() + 6) % 7;
                this.week.num = Math.ceil((dayOfYear - weekDay + 9) / 7);
                if (this.week.num >= 52 && d.getUTCMonth() === 0) this.week.year = d.getUTCFullYear() - 1;
                else if (this.week.num === 1 && d.getUTCMonth() === 11) this.week.year = d.getUTCFullYear() + 1;
                else this.week.year = d.getUTCFullYear();
                this.loadHistory();
            },
            weekNavBack() {
                this.weekNav(-1);
            },
            weekNavForward() {
                this.weekNav(1);
            },
            loadHistory() {
                this.loading = true;
                return api.getProductionHistory(this.week.year, this.week.num).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.updateUrl();
                    this.users = data.users;
                    this.week = data.week;
                });
            },
            loadUsersCompleted(user_id, date, date_index) {
                this.loading = true;
                this.usersCompleted = [];
                this.usersCompletedModalVisible = true;

                let start_date = date;
                let end_date = date;
                if (date === 'week_total') {
                    start_date = this.week.start_short;
                    end_date = this.week.end_short;
                }

                this.usersCompletedModalUser = this.users[user_id].name;
                this.usersCompletedModalDateRange = start_date === end_date
                    ? this.week.days[date_index]
                    : this.week.days[0] + ' - ' + this.week.days[6];

                return api.getProductionHistoryUsersCompleted(user_id, start_date, end_date).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.usersCompleted = data;
                });
            },
            formatMetric(name, value) {
                if (value === undefined || value === null)
                    return '';

                if (value === '0')
                    return '0';

                if (name === 'pounds_done' || name === 'pounds_per_hour')
                    return '£' + value;

                if (name === 'time_percent_efficiency')
                    return value + '%';

                return value;
            },
            poundsPerHourValue(pounds_per_hour, pounds_per_hour_percent) {
                // if the we have some value but the percent ends up as zero, change it to 1 to force the highlighting
                return pounds_per_hour_percent === '0' && pounds_per_hour !== '0' ? '1' : pounds_per_hour_percent;
            },
            cellHighlighting(values) {
                let value = this.metric === 'pounds_per_hour'
                    ? this.poundsPerHourValue(values.pounds_per_hour, values.pounds_per_hour_percent)
                    : values[this.metric]

                if (value === undefined || value === null) return '';

                value = value.replace(',', '');

                if (value === '0')
                    return 'grey-zero-value';

                // if (this.metric !== 'time_percent_efficiency' && this.metric !== 'pounds_per_hour')
                if (this.metric !== 'pounds_per_hour')
                    return '';


                let num = (Math.floor(value/25) + 1) * 25;
                if (num > 100)
                    num = 100;

                return 'ph-' + num + '-percent';
            },
        },

        computed: {
            url() {
                return `${this.app_url}/history/${this.week.year}/${this.week.num}`;
            },
            metric_select_options() {
                let options = [
                    {'id': 'hours_capacity', 'name': 'Hours Capacity'},
                    {'id': 'hours_done', 'name': 'Hours Done'},
                    {'id': 'time_percent_efficiency', 'name': 'Time Percent Efficiency'},
                ];
                if (this.can_view_financials) {
                    options.push({'id': 'pounds_done', 'name': 'Value Done'});
                    options.push({'id': 'pounds_per_hour', 'name': 'Value Per Hour'});
                }
                return options;
            },
        },

    }

</script>

<style>

    .checklist-header h1 .fas {
        margin-right: 15px;
    }
    .checklist-header h1 {
        font-size: 28px;
    }
    @media (min-width: 768px) {
        .checklist-header h1 {
            font-size: 36px;
        }
    }

    .loadingfade { opacity: 0.5; }
    .stat {
        display: inline-block;
        min-width: 28px;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        border-radius: 3px;
        margin-right: 10px;
        background-color: #6b6f6b;
        opacity: 0.75;
        flex-shrink: 0;
    }
    @media (min-width: 992px) {
        .stat {
            padding: 5px 7px;
            font-size: 14px;
            font-weight: 600;
            margin-right: 20px;
        }
    }
    .small-stat {
        background-color: #979797;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 600;
    }
    .stat-name {
        background-color: #fff;
        padding: 3px 5px;
        font-size: 11px;
        font-weight: 400;
        color: #313131;
        border: 1px solid #a8a8a8;
    }
    .stat a, .stat a:visited {
        color: #fff;
    }
    .checklist-header {
        display: flex;
        margin: 10px 0 10px 0;
        justify-content: space-between;
        align-items: center;
    }
    .checklist-subtitle {
        display: block;
        padding: 15px 0 0 25px;
        color: #666;
        margin: 0 24px;
        font-size: 15px;
    }
    @media (min-width: 768px) {
        .checklist-subtitle {
            font-size: 18px;
            padding: 15px 0 0 34px;
        }
    }
    .subtitleCurrentWeek {
        border-bottom: 2px solid #428c38;
        color: #14590b;
    }
    .checklist-week-nav {
        display: flex;
        height: 40px;
    }
    .checklist-week-nav button {
        font-size: 18px;
        color: #6c6c6c;
        margin: 0 5px;
    }
    .mini-toastr {
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
    }
    .mini-toastr-notification__message {
        padding: 0 !important;
    }
    #messages {
        position: relative;
    }
    .mini-toastr__notification.-success {
        background-color: #15831a !important;
    }


    .ps-filter-row {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
    }
    .ps-filter-col {
        flex-grow: 1;
        max-width: 20%;
        margin-left: 40px;
    }
    .ps-filter-col-btn {
        flex-grow: 0;
        max-width: 20%;
    }


    .tt-filter-active {}

    .tt-filter .vs__selected {
        white-space: nowrap;
    }
    .tt-filter .vs__selected-options {
        overflow: hidden;
        flex-wrap: nowrap;
    }
    .tt-filter .vs__state-active-bg {
        overflow: hidden;
    }


    .row-filter {
        margin-bottom: 20px;
    }
    .col-filter {
        margin-top: 15px;
        border: 2px solid #fff;
        border-radius: 5px;
    }
    @media (min-width:992px) {
        .col-filter {
            margin-top: 0;
        }
    }

    .col-filter-label {
        font-size: 18px;
        margin: 0 0 8px 0;
        color: #505050;
    }
    .col-filter-badge {
        margin: 0 0 0 10px;
        background-color: #bfbfbf;
        color: #fff;
        border-radius: 4px;
        display: inline-block;
        font-size: 12px;
        vertical-align: top;
    }

    .col-filter-active .vs__dropdown-toggle {
        border: 1px solid #9ea193;
    }
    .col-filter-active .col-filter-label {
        font-weight: bold;
        color: #3f3f3f;
    }

    .col-filter-highlight {
        border: 2px solid #808080;
    }


    .nopoint {
        pointer-events: none;
    }
    .large-status {
    }
    .large-status .vs__open-indicator,
    .large-status .vs__actions,
    .large-status .vs__search {

    }
    .large-status .vs__search {
        padding: 0;
    }
    .large-status .vs__dropdown-toggle {
        border: none;
    }
    .large-status.vs--single.vs--open .vs__selected {
        position: relative;
    }
    .large-status .vs__dropdown-option--selected,
    .large-status .vs__dropdown-option,
    .large-status .vs__dropdown-option--highlight,
    .large-status .vs__dropdown-option--selected:hover,
    .large-status .vs__dropdown-option:hover,
    .large-status .vs__dropdown-option--highlight:hover {
        background-color: #fff;
    }

    .large-status.vs--disabled .vs__clear, .large-status.vs--disabled .vs__dropdown-toggle,
    .large-status.vs--disabled .vs__open-indicator, .large-status.vs--disabled .vs__search,
    .large-status.vs--disabled .vs__selected {
        background-color: #fff;
        opacity: 0.9;
    }
    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        filter: alpha(opacity=90) !important;
        opacity: .9 !important;
    }


    .vs__dropdown-option {
        padding: 6px 20px;
        font-size: 18px;
    }

    .vs__clear {
        fill: rgba(95, 95, 95, 0.5);
        padding: 0;
        border: 1px solid #e0e0e0;
        background-color: #e7e7e7;
        cursor: pointer;
        margin: 0 4px 0 0;
        width: 25px;
        height: 25px;
        border-radius: 20px;
    }
    @media (min-width: 1200px) {
        .vs__clear {
            margin: 0 12px 0 0;
        }
    }


    .btn-large-status {
        color: #fff;
        font-size: 35px;
        padding: 6px 16px;
        margin: 0 10px 0 0;
    }
    .btn-large-status .fa {
        color: #fff;
    }
    .btn-large-status:hover, .btn-large-status:active .btn-large-status:focus {
        color: #fff;
    }
    .large-status-badge {
        font-size: 15px;
        padding: 5px 10px;
    }
    @media (min-width: 1200px) {
        .large-status-badge {
            font-size: 18px;
        }
    }

    .grey-zero-value {
        color: #dfdfdf;
    }

    .ph-25-percent {
        background-color: rgba(255, 0, 0, 0.25);
    }
    .ph-50-percent {
        background-color: rgba(255, 165, 0, 0.25);
    }
    .ph-75-percent {
        background-color: rgba(255, 255, 0, 0.25);
    }
    .ph-100-percent {
        background-color: rgba(0, 128, 0, 0.25);
    }

    .ph-value-cell {
        cursor: pointer;
    }
    .ph-value-cell:hover {
        font-weight: bold;
    }



    .v-easy-dialog--backdrop {
        background-color: #00000080;
    }
    .v-easy-dialog--backdrop-btn {
        opacity: 0;
    }
    .v-easy-dialog--content-container {
        display: flex;
        overflow-y: auto;
        position: absolute;
    }
    .ph-dialog-wrap {
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        background-color: white;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000);
    }
    .ph-dialog-title {
        border-bottom: 1px solid #cbcbcb;
        padding: 18px 24px 14px;
        background-color: #dbeed8;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    .ph-dialog-content {
        overflow-y: auto;
        flex-grow: 1;
        padding: 16px 24px;
    }
    .ph-dialog-item {
        margin: 10px 0 30px 0;
    }
    .ph-dialog-item-title {
        font-weight: bold;
        display: flex;
        flex-direction: column;
        margin: 0 0 5px 0;
    }
    .ph-dialog-item-title span {
        font-size: 14px;
        opacity: 0.6;
    }
    .ph-dialog-process {
        display: flex;
        flex-direction: row;
        margin: 0 0 5px 20px;
    }
    .ph-dialog-process div {
        margin-right: 25px;
    }
    .ph-dialog-stat {
        background-color: #fff;
        padding: 0 7px;
        font-size: 12px;
        font-weight: 400;
        color: #333;
        border: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        text-align: center;
    }

</style>









